import { render, staticRenderFns } from "./formSpecificPlanPrevention.vue?vue&type=template&id=2261f09e&"
import script from "./formSpecificPlanPrevention.vue?vue&type=script&lang=js&"
export * from "./formSpecificPlanPrevention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports